module.exports = __webpack_public_path__ + "static/media/conveyor-belt.d1e64fc5.svg";